import * as localStorage from '../localStorage';

const getKeyData = async (storageKey: string) => {
  const localeStorageItem = await localStorage.getItem<string>(storageKey);
  if (!localeStorageItem) {
    return {};
  }

  try {
    return JSON.parse(localeStorageItem);
  } catch {
    return localeStorageItem;
  }
};

const getItem = async (storageKey: string, userId: string | number) => {
  const keyData = await getKeyData(storageKey);
  return keyData[String(userId)];
};

const setLocalstorage = (storageKey: string, values: Record<string, unknown>) =>
  localStorage.setItem(storageKey, values);

const setItem = async (storageKey: string, userId: string | number, values: unknown) => {
  const keyData = await getKeyData(storageKey);
  const newValues = {
    ...keyData,
    [String(userId)]: values,
  };

  return setLocalstorage(storageKey, newValues);
};

const addItem = async (storageKey: string, userId: string, values: unknown) => {
  const keyData = await getKeyData(storageKey);
  const newValues = {
    ...keyData,
    [userId]: {
      ...keyData[userId],
      ...values,
    },
  };

  return setLocalstorage(storageKey, newValues);
};

const deleteItem = async (storageKey: string, userId: string) => {
  const keyData = await getKeyData(storageKey);
  const newValues = Object.keys(keyData).reduce((acc, item) => {
    if (item === userId.toString()) return acc;
    return {
      ...acc,
      [item]: keyData[item],
    };
  }, {});

  setLocalstorage(storageKey, newValues);
};

const deleteOtherUsersData = async (storageKey: string, userId: string) => {
  const keyData = await getKeyData(storageKey);

  if (!keyData) {
    return;
  }

  const newValues = { [userId]: keyData[userId] };

  setLocalstorage(storageKey, newValues);
};

export default {
  getItem,
  setItem,
  addItem,
  deleteItem,
  deleteOtherUsersData,
};
